"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ATImportEngine", {
    enumerable: true,
    get: function() {
        return ATImportEngine;
    }
});
const _axios = /*#__PURE__*/ _interop_require_default(require("axios"));
const _airtable = /*#__PURE__*/ _interop_require_default(require("airtable"));
const _mock = require("./mock");
const _utils = require("~/helpers/utils");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let ATImportEngine = class ATImportEngine extends _mock.ATMockImportEngine {
    static get() {
        if ((0, _utils.isPlayWrightNode)()) {
            return new _mock.ATMockImportEngine();
        }
        return new ATImportEngine();
    }
    async initialize({ appId, shareId }) {
        const url = `https://airtable.com/${appId ? `${appId}/` : ''}${shareId}`;
        return await _axios.default.get(url, {
            headers: {
                accept: 'text/html,application/xhtml+xml,application/xml;q=0.9,image/avif,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.9',
                'accept-language': 'en-US,en;q=0.9',
                'sec-ch-ua': '" Not A;Brand";v="99", "Chromium";v="100", "Google Chrome";v="100"',
                'sec-ch-ua-mobile': '?0',
                'sec-ch-ua-platform': '"Linux"',
                'sec-fetch-dest': 'document',
                'sec-fetch-mode': 'navigate',
                'sec-fetch-site': 'none',
                'sec-fetch-user': '?1',
                'upgrade-insecure-requests': '1',
                'User-Agent': 'Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/100.0.4896.88 Safari/537.36'
            },
            // @ts-ignore
            referrerPolicy: 'strict-origin-when-cross-origin',
            body: null,
            method: 'GET'
        });
    }
    async read(info) {
        return await (0, _axios.default)('https://airtable.com' + info.link, {
            headers: _extends({
                accept: '*/*',
                'accept-language': 'en-US,en;q=0.9',
                'sec-ch-ua': '" Not A;Brand";v="99", "Chromium";v="100", "Google Chrome";v="100"',
                'sec-ch-ua-mobile': '?0',
                'sec-ch-ua-platform': '"Linux"',
                'sec-fetch-dest': 'empty',
                'sec-fetch-mode': 'cors',
                'sec-fetch-site': 'same-origin',
                'User-Agent': 'Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/100.0.4896.88 Safari/537.36',
                'x-time-zone': 'Europe/Berlin',
                cookie: info.cookie
            }, info.headers),
            // @ts-ignore
            referrerPolicy: 'no-referrer',
            body: null,
            method: 'GET',
            responseType: 'stream'
        });
    }
    async readView(viewId, info) {
        return await (0, _axios.default)(`https://airtable.com/v0.3/view/${viewId}/readData?` + `stringifiedObjectParams=${encodeURIComponent(JSON.stringify({
            mayOnlyIncludeRowAndCellDataForIncludedViews: true,
            mayExcludeCellDataForLargeViews: true
        }))}&requestId=${info.baseInfo.requestId}&accessPolicy=${encodeURIComponent(JSON.stringify({
            allowedActions: info.baseInfo.allowedActions,
            shareId: info.baseInfo.shareId,
            applicationId: info.baseInfo.applicationId,
            generationNumber: info.baseInfo.generationNumber,
            expires: info.baseInfo.expires,
            signature: info.baseInfo.signature
        }))}`, {
            headers: _extends({
                accept: '*/*',
                'accept-language': 'en-US,en;q=0.9',
                'sec-ch-ua': '" Not A;Brand";v="99", "Chromium";v="100", "Google Chrome";v="100"',
                'sec-ch-ua-mobile': '?0',
                'sec-ch-ua-platform': '"Linux"',
                'sec-fetch-dest': 'empty',
                'sec-fetch-mode': 'cors',
                'sec-fetch-site': 'same-origin',
                'User-Agent': 'Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/100.0.4896.88 Safari/537.36',
                'x-time-zone': 'Europe/Berlin',
                cookie: info.cookie
            }, info.headers),
            // @ts-ignore
            referrerPolicy: 'no-referrer',
            body: null,
            method: 'GET',
            responseType: 'stream'
        });
    }
    atBase({ apiKey, baseId }) {
        if (process.env.DEBUG_MOCK_AIRTABLE_IMPORT === 'true') {
            return (title)=>new _mock.MockAirtable(title);
        }
        return new _airtable.default({
            apiKey: apiKey
        }).base(baseId);
    }
};
